import { render, staticRenderFns } from "./addCustomers.vue?vue&type=template&id=4f2d1802"
import script from "./addCustomers.vue?vue&type=script&lang=js"
export * from "./addCustomers.vue?vue&type=script&lang=js"
import style0 from "./addCustomers.vue?vue&type=style&index=0&id=4f2d1802&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f2d1802')) {
      api.createRecord('4f2d1802', component.options)
    } else {
      api.reload('4f2d1802', component.options)
    }
    module.hot.accept("./addCustomers.vue?vue&type=template&id=4f2d1802", function () {
      api.rerender('4f2d1802', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/customers/components/addCustomers.vue"
export default component.exports